import { render, staticRenderFns } from "./transferInPurchase.vue?vue&type=template&id=a0b1b674&scoped=true"
import script from "./transferInPurchase.vue?vue&type=script&lang=js"
export * from "./transferInPurchase.vue?vue&type=script&lang=js"
import style0 from "./transferInPurchase.vue?vue&type=style&index=0&id=a0b1b674&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1b674",
  null
  
)

export default component.exports